import "core-js/modules/es.array.index-of";

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
export var isInputElement = function isInputElement(element) {
  return !!element && (element.nodeName === 'INPUT' && ['text', 'tel', 'email', 'number', 'password'].indexOf(element.type) !== -1 || element.nodeName === 'TEXTAREA');
};
export var isKeySpecial = function isKeySpecial(event) {
  var keyCode = event.keyCode,
      metaKey = event.metaKey,
      ctrlKey = event.ctrlKey; // Allow: backspace, delete, tab, escape, and enter. Also allow 229 and 0 for Android

  if ([46, 8, 9, 27, 13, 110, 229, 0].indexOf(keyCode) !== -1 || // Allow: select all, cut, copy
  [65, 67, 88].indexOf(keyCode !== -1) && (ctrlKey === true || metaKey === true) || // Allow: home, end, left, right, down, up
  keyCode >= 35 && keyCode <= 40) {
    return true;
  }

  return false;
};
export var isKeyNumeric = function isKeyNumeric(event) {
  var keyCode = event.keyCode,
      shiftKey = event.shiftKey;
  return !((shiftKey || keyCode < 48 || keyCode > 57) && (keyCode < 96 || keyCode > 105));
};
export var isKeyMinus = function isKeyMinus(_ref) {
  var key = _ref.key;
  return key === '-';
};
export var isKeyValidForDates = function isKeyValidForDates(event) {
  return isKeyNumeric(event) || isKeySpecial(event) || event.key === '/';
};